import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectedPreviewRequirementFileIdSelector } from "../../../../../store/selectors/application";
import FilePreview from "./FilePreview";
export default connect(createStructuredSelector({
  selectedPreviewRequirementFileId: selectedPreviewRequirementFileIdSelector
}))(FilePreview);